/* eslint-disable max-classes-per-file */
import { convertToBoolean } from "@/utils/common/formatHelper/booleanUtills";

// eslint-disable-next-line max-classes-per-file
export interface RequestPromotionDetailInterface {
  id?: number;
  slug?: string;
}

export interface SeoInterface {
  title: string;
  description: string;
}

export class PromotionDetail {
  id: number;

  title: string;

  description: string;

  startPrice: number;

  currency: string;

  product: string;

  fullImage: string;

  thumbImage: string;

  mobileImage: string;

  startDate: string;

  expireDate: string;

  is_gother: string;

  status: string;

  slug: string;

  url: string;

  seo: SeoInterface;

  constructor(data: any) {
    this.id = data.id || 0;
    this.title = data.title || "";
    this.description = data.description || "";
    this.startPrice = data.startPrice || 0;
    this.currency = data.currency || "";
    this.product = data.product || "";
    this.fullImage = data.fullImage || "";
    this.thumbImage = data.thumbImage || "";
    this.mobileImage = data.mobileImage || "";
    this.startDate = data.startDate || "";
    this.expireDate = data.expireDate || "";
    this.is_gother = data.is_gother || "";
    this.status = data.status || "";
    this.slug = data.slug || "";
    this.url = data.url || "";
    this.seo = {
      title: data.seo.title || "",
      description: data.seo.description || "",
    };
  }
}
export class ResponsePromotionDetail {
  promotions: PromotionDetail[];

  destinationType: number;

  success: boolean;

  isRequireLogin: boolean;

  constructor(data: any) {
    this.destinationType = data.destination_type ?? 9;
    this.promotions = (data.promotions || []).map(
      (promotion: any) => new PromotionDetail(promotion),
    );

    this.success = data.success || false;

    this.isRequireLogin = convertToBoolean(data.isRequireLogin);
  }
}
